import axios from 'axios'

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 10000,
  transformResponse: [data => JSON.parse(data).data],
  withCredentials: true,
  headers: { 'App-Name': 'blaze' }
})

export const login = payload => {
  return axiosInstance.post('auth/login', payload)
}

export const logout = () => {
  return axiosInstance.post('auth/logout')
}
